<script setup lang="ts">
import type { SiteInfoFragment } from '#gql';

const props = defineProps<{
  variant?: 'default' | 'underline';
}>();

const siteInfo = useNuxtApp().$siteInfo as SiteInfoFragment;
</script>

<template>
  <a
    v-if="siteInfo.linkLocation"
    class="map"
    :class="props.variant"
    :href="siteInfo.linkLocation"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img class="icon" src="/icons/map.svg" />
    <span class="text">{{ $t('locationLink') }}</span>
  </a>
</template>

<style scoped lang="scss">
.map {
  display: flex;
  gap: 0.5rem;

  .icon {
    width: 1.5rem;
    height: 1.5rem;
    margin-block: auto;
  }

  &.underline {
    text-decoration-line: none;

    .text {
      position: relative;

      &::after,
      &::before {
        content: '';
        width: 100%;
        height: 2px;
        background-color: rgba(9, 89, 139, 0.2);
        position: absolute;
        bottom: 0;
        left: 0;
        transition: transform 0.3s ease-in-out;
      }

      &::after {
        transform: scaleX(0);
        transform-origin: left;
        background-color: var(--color-blue-500);
      }

      &:hover {
        &::after {
          transform: scaleX(1);
        }
      }
    }
  }
}
</style>
